export default __webpack_public_path__ + "static/media/Polymorph Lycanthropic Morph.2ece7fdb.jpg";